const host = '/api/';

// UI参考网站
// https://www.vam.ac.uk/shop

// 接口文档
// https://www.showdoc.cc/2598838444445365
// d4THvZi6

export default {
    home: `${host}index`, //首页
    about: `${host}about-us`, //关于我们
    aboutMore: `${host}about-us-info`, //关于我们 - 二级页
    message: `${host}message`, //留言
    contactUs: `${host}contact-us`, //联系我们
    code: `${host}code`, // 短信验证码
    login: `${host}login`, //登录
    reg: `${host}reg`, //注册
    getUserinfo: `${host}info`, //获取用户信息，判断token是否有效
    seo: `${host}seo`,
    upImage: `${host}image`,        //上传图片

    talentMenu: `${host}talent-category`, //人才 - 菜单
    talentList: `${host}artist-list`, //人才 - 艺人列表|艺术家列表
    talentImages: `${host}artist-works`, //人才 - 艺术家图片组|主题详情
    talentIp: `${host}artist-info`, //人才 - 形象ip详情
    talentMuseum: `${host}artist-museum`, //人才 - 博物馆

    news: `${host}news-list`, //新闻 - 列表
    newsDetail: `${host}news-info`, //新闻 - 详情

    studyMenu: `${host}study-category`, //学习 - 菜单
    studyList: `${host}study-list`, //学习 - 列表
    studyDetail: `${host}study-info`, //学习 - 详情

    shopMenu: `${host}shop-category`, //商店 - 菜单
    shopHome: `${host}shop-index`, //商店 - 首页|一级页面
    shopFilter: `${host}shop-list`, //商店 - 筛选
    shopDetail: `${host}shop-info`, //商店 - 详情
    shopAddCart: `${host}add-cart`, //商店 - 新增购物车
    shopCartList: `${host}cart-list`, //商店 - 购物车列表
    shopCartCount: `${host}modify-cart`, //商店 - 修改购物车数量
    shopCartDelete: `${host}del-cart`, //商店 - 删除

    galleryHome: `${host}gallery-index`, //画廊 - 首页
    galleryAbout: `${host}gallery-about`, //画廊 - 关于我们
    galleryCategory: `${host}gallery-category`, //画廊 - 筛选
    galleryList: `${host}gallery-list`, //画廊 - 展览列表
    galleryDetail: `${host}gallery-info`, //画廊 - 详情
    galleryArtist: `${host}gallery-artist-list`, //画廊 - 艺术家列表
    galleryArtistDetail: `${host}gallery-artist-info`, //画廊 - 艺术家详情
    galleryWorks: `${host}gallery-work-list`, //画廊 - 作品列表
    galleryWorksDetail: `${host}gallery-work-info`, //画廊 - 作品详情
    galleryExhibitionJoin: `${host}exhibition-order`, //画廊 - 画展预约

}